import React from 'react';
import { Modal, Button } from '../design-system';
import { cleanName } from '../utils/textUtils';

const T = {
  ink2: '#4A3510',
  sans: '"Nunito", ui-sans-serif, system-ui, -apple-system, sans-serif',
};

/**
 * Confirmation modal for deleting an idea. Same shape used in IdeaCard so
 * dashboard / ideas-list deletion flows feel consistent.
 *
 * Props:
 *   idea: { name } — used to name the idea in the prompt
 *   isOpen: bool
 *   onCancel(): closes without deleting
 *   onConfirm(): commits the deletion
 *   busy: bool — disables the confirm button while the request is in flight
 */
export default function DeleteIdeaConfirmModal({ idea, isOpen, onCancel, onConfirm, busy }) {
  return (
    <Modal isOpen={isOpen} onClose={onCancel} title="Delete idea" size="sm">
      <p style={{ marginBottom: 16, color: T.ink2, fontFamily: T.sans, fontSize: 14 }}>
        Are you sure you want to delete{' '}
        <strong>{cleanName(idea?.name) || 'this idea'}</strong>? This will also
        delete all associated plans, stories, and drift state — and cannot be
        undone.
      </p>
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
        <Button variant="ghost" onClick={onCancel} disabled={busy}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onConfirm} disabled={busy}>
          {busy ? 'Deleting…' : 'Delete'}
        </Button>
      </div>
    </Modal>
  );
}
